/**
 * 把应用语言同步给 React Aria（HeroUI DatePicker / Calendar 等）。
 * 必须用 `@react-aria/i18n`（与 HeroUI 嵌套的 react-aria 同一 Context）。
 */

import { I18nProvider } from "@react-aria/i18n";
import type { ReactNode } from "react";

import { useAppI18n } from "../../i18n/context";
import { formatLocale } from "../../lib/utils/format-locale";

export const AriaI18nProvider = ({ children }: { children: ReactNode }) => {
  const { locale } = useAppI18n();
  return (
    <I18nProvider locale={formatLocale(locale)}>{children}</I18nProvider>
  );
};
